const Pryv = require('./Pryv');

module.exports = Pryv;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pryv/src/index.js
// module id = +T3g
// module chunks = 0